import { SecurityHelper } from 'sarsaparilla';
import axios from 'axios';
import * as types from '../constants';

export function fetchCart() {
    return (dispatch) => axios.get(`${process.env.API}/cart/shoppingcart`, { headers: { Authorization: SecurityHelper.getAuthHeader() } })
        .then((response) => {
            dispatch({ type: types.GET_CART, payload: response.data });
        })
        .catch(() => {
          dispatch({
                type: types.CART_ERROR,
                payload: 'Error fetching cart',
                error: true
            });
        });
}

export function removeReservation(reservationID) {
    return (dispatch) => axios.delete(`${process.env.API}/cart/shoppingcart/${reservationID}`, { headers: { Authorization: SecurityHelper.getAuthHeader() } })
        .then((response) => {
            dispatch({ type: types.GET_CART, payload: response.data });
        })
        .catch(() => {
            dispatch({ type: types.REMOVE_RESERVATION_ERROR, payload: 'Error removing item from cart' });
        });
}

export function extendTimer() {
    return (dispatch) => axios.patch(`${process.env.API}/cart/shoppingcart/expiration`, {}, { headers: { Authorization: SecurityHelper.getAuthHeader() } })
    .then((response) => {
        dispatch({ type: types.GET_CART, payload: response.data });
    })
    .catch(() => {
        dispatch({ type: types.EXTEND_EXPIRATION_ERROR, payload: 'Error extending expiration' });
});
}
